export default __webpack_public_path__ + "static/media/960.53e060c8.gif";